import { Cell } from '@pelckmans/elementis/components/table';

interface TocNodeResultCellProps {
  maximum: number;
  achieved: number;
  achievable: number;
  pending: number;
}

export default function TocNodeResultCell({ achievable, achieved, maximum, pending }: TocNodeResultCellProps) {
  if (maximum === 0) return <Cell highlighted />;

  return (
    <Cell highlighted>
      <Cell.Results
        awaiting={pending}
        success={achieved}
        failure={achievable - achieved}
        undone={maximum - (achievable + pending)}
        quantifiable
        variant="bar"
      />
    </Cell>
  );
}
